// Signs this browser out when its device session is removed elsewhere (src/main.js).
//
// Fixed 14 Oct 2026 (CUELIST_SESSION_HANG_2026-10-14.md): the session id was read when the 5 s
// logout timer FIRED, not when it was scheduled, and nothing was stopped on sign-out. So every
// sign-out from the menu ran a late logout with id null, after the sign-out, which wrote
// `userDeviceSession.null` as "no user". That write is never sent while the browser stays
// signed in, and it stalled the Firebase SDK's waitForPendingWrites.
//
// Dependencies are passed in so this can be tested without Firebase or a browser.

export function isRealSessionId(id) {
    return typeof id === 'string' && id !== '' && id !== 'null' && id !== 'undefined';
}

// A session delete is written only for a real id, signed in as the user it belongs to.
export function sessionDeleteAllowed(currentUser, userId, sessionId) {
    return !!(currentUser && currentUser.uid === userId && isRealSessionId(sessionId));
}

// Returns stop(): call it on sign-out. It stops the listener, the interval and a pending logout.
export function watchSession(userId, deps) {
    let sessionId = deps.storage.getItem('sessionID');
    let sessionIdDateTime = deps.storage.getItem('sessionIDDateTime');
    const interval = deps.setInterval(() => {
        sessionId = deps.storage.getItem('sessionID');
        sessionIdDateTime = deps.storage.getItem('sessionIDDateTime');
    }, 1000);
    const isSessionStale = () => {
        if (!sessionIdDateTime) return true;
        return (Date.now() - new Date(sessionIdDateTime).getTime()) > 30 * 1000;
    };
    let timer = null;
    const unsubscribe = deps.onUserDoc(userId, (doc) => {
        if (!isRealSessionId(sessionId) || !isSessionStale() || timer) return;
        const userData = (doc && doc.data()) || {};
        const sessions = userData.userDeviceSession;
        if (sessions && Object.prototype.hasOwnProperty.call(sessions, sessionId)) return;
        const removedId = sessionId; // captured now, not when the timer fires
        timer = deps.setTimeout(() => {
            timer = null;
            deps.logout(userId, removedId);
        }, 5000);
    });
    return () => {
        deps.clearInterval(interval);
        deps.clearTimeout(timer);
        timer = null;
        unsubscribe();
    };
}


// WEBPACK FOOTER //
// ./src/lib/session-watch.js